import { TARGET_PRODUCTS } from '@/components/target-products/gql';
import ProductsService from '@/service/products-service';

export default class TargetProductsUtils {
  static products = [];

  static async getProducts() {
    if (TargetProductsUtils.products.length !== 0)
      return TargetProductsUtils.products;

    const response = await ProductsService.getProducts(TARGET_PRODUCTS);

    TargetProductsUtils.products = response;

    return response;
  }
}
